var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "container-withdraw-method",
      class: [_vm.$i18n.locale === "ar" ? "ar-style" : "", _vm.packageName],
    },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          style: `padding-top:${_vm.barHeight}px; background-color: #f7f6f9;`,
        },
        [
          _c("van-nav-bar", {
            staticClass: "van-bar",
            attrs: { title: "", "left-arrow": "" },
            on: { "click-left": _vm.goPrevious },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("@/assets/packageAssets/common/arrow05.png"),
                        alt: "",
                      },
                    }),
                    _c("span", { staticClass: "tit-left" }, [
                      _vm._v(_vm._s(_vm.$t("lang.wd.withdrawalMethod"))),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "right",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "right-nav",
                      attrs: { src: _vm._f("imgPath")(_vm.locaFlag), alt: "" },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "main" },
        [
          _c("span", { staticClass: "tit" }, [
            _vm._v(_vm._s(_vm.$t("lang.wd.methodTit"))),
          ]),
          _vm._l(_vm.withdrawMethodList, function (item) {
            return _c(
              "div",
              {
                key: item,
                staticClass: "method",
                class: {
                  methidDis:
                    _vm.minPrice && _vm.minPrice < item.minDollarAmount,
                },
                on: {
                  click: function ($event) {
                    item.flag && _vm.handleChooseAccount(item)
                  },
                },
              },
              [
                _c("div", {
                  staticClass: "method-ifSupport",
                  class: { ifSupport: !item.ifSupport },
                  on: { click: _vm.handleIfSupport },
                }),
                _c("img", {
                  attrs: { src: _vm._f("imgPath")(item.icon), alt: "" },
                }),
                _c("span", { staticClass: "line" }),
                _c("div", { staticClass: "bind" }, [
                  _c("div", { staticClass: "name" }, [
                    _c("span", [_vm._v(_vm._s(item.withdrawalMethod))]),
                    _c("div", { staticClass: "tags-wrapper" }, [
                      _c("div", { staticClass: "fee" }, [
                        _c("span", [_vm._v(_vm._s(item.desc))]),
                      ]),
                      item.ifInstantPay
                        ? _c("div", { staticClass: "fee" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("lang.instantPayment.instant"))
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "bind-btn" },
                    [
                      !item.ifSupport
                        ? _c("img", {
                            attrs: {
                              src: require("@/assets/packageAssets/views/P1_Girls/WithdrawalBind/vava/icon_lock.png"),
                              alt: "",
                            },
                          })
                        : _vm._e(),
                      item.withdrawalMethod === "USDT(BINANCE)"
                        ? [
                            _c(
                              "van-popover",
                              {
                                attrs: {
                                  trigger: "",
                                  theme: "dark",
                                  placement: "bottom-end",
                                },
                                on: {
                                  select: function ($event) {
                                    _vm.tipsVisible = false
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "reference",
                                      fn: function () {
                                        return [
                                          item.flag == "true"
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "span change-btn",
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.handleChangeAccount(
                                                        item.icon,
                                                        item.withdrawalMethod,
                                                        _vm.locaFlag,
                                                        _vm.locaCode,
                                                        _vm.walletType,
                                                        item.minDollarAmount,
                                                        "change",
                                                        item.canModify
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t("lang.change")
                                                      ) +
                                                      " "
                                                  ),
                                                  _c("van-icon", {
                                                    staticClass: "arrow",
                                                    attrs: { name: "arrow" },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticClass: "span",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleBindAccount(
                                                        item.icon,
                                                        item.withdrawalMethod,
                                                        _vm.locaFlag,
                                                        _vm.locaCode,
                                                        _vm.walletType,
                                                        item.minDollarAmount
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t("lang.bind")
                                                      ) +
                                                      " "
                                                  ),
                                                  _c("van-icon", {
                                                    staticClass: "arrow",
                                                    attrs: { name: "arrow" },
                                                  }),
                                                ],
                                                1
                                              ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: _vm.tipsVisible,
                                  callback: function ($$v) {
                                    _vm.tipsVisible = $$v
                                  },
                                  expression: "tipsVisible",
                                },
                              },
                              [
                                _c("div", { staticClass: "tips_wrapper" }, [
                                  _vm._v(_vm._s(_vm.$t("lang.wd.addressTips"))),
                                ]),
                              ]
                            ),
                          ]
                        : [
                            item.flag == "true"
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "span change-btn",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handleChangeAccount(
                                          item.icon,
                                          item.withdrawalMethod,
                                          _vm.locaFlag,
                                          _vm.locaCode,
                                          _vm.walletType,
                                          item.minDollarAmount,
                                          "change",
                                          item.canModify
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("lang.change")) + " "
                                    ),
                                    _c("van-icon", {
                                      staticClass: "arrow",
                                      attrs: { name: "arrow" },
                                    }),
                                  ],
                                  1
                                )
                              : _c(
                                  "span",
                                  {
                                    staticClass: "span",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleBindAccount(
                                          item.icon,
                                          item.withdrawalMethod,
                                          _vm.locaFlag,
                                          _vm.locaCode,
                                          _vm.walletType,
                                          item.minDollarAmount
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("lang.bind")) + " "
                                    ),
                                    _c("van-icon", {
                                      staticClass: "arrow",
                                      attrs: { name: "arrow" },
                                    }),
                                  ],
                                  1
                                ),
                          ],
                    ],
                    2
                  ),
                ]),
              ]
            )
          }),
        ],
        2
      ),
      _c("c-confirm", {
        attrs: {
          headline: _vm.headline,
          title: _vm.title,
          showDiaC: _vm.showDiaConfirm,
          oneShow: _vm.oneShow,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }